// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1VgcT","select":"Header_select__2hnHP","clinic":"Header_clinic__1I0gi"};